import { render, staticRenderFns } from "./confrim.vue?vue&type=template&id=3a828b7c&scoped=true&"
import script from "./confrim.vue?vue&type=script&lang=js&"
export * from "./confrim.vue?vue&type=script&lang=js&"
import style0 from "./confrim.vue?vue&type=style&index=0&id=3a828b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a828b7c",
  null
  
)

export default component.exports